<template>
  <component :is="url ? 'a' : 'button'"
             :href="url"
             :class="classes"
             target="_blank"
             @click="onClick">
    {{ label }}
  </component>
</template>

<script>
  import {mapActions} from 'vuex';
  import { getQueryStringParams } from '../lib/utils';

  export default {
    name: 'Button',
    props: {
      label: {
        type: String,
        required: true
      },
      url: {
        type: String
      },
      message: {
        type: String
      },
      outline: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
          classes: {
            'btn-reset': true,
            'rounded-lg': true,
            'text-primary': true,
            'bg-light': !this.outline,
            'bg-transparent': this.outline,
            'border': this.outline,
            'border-primary': this.outline,
            'd-flex': true,
            'align-items-center': true,
            'justify-content-center': true,
            'px-3': true,
            'py-2': true,
            'text-uppercase': true,
            'text-decoration-none': true
          }
        };
    },
    methods: {
      ...mapActions(['sendMessage']),
      onClick() {
        if (this.message) this.sendMessage(this.message);
        this.$emit('click');
      }     
    }
  }
</script>

<style lang="scss" module>
  .root {
    cursor: pointer;
  }
</style>
